import { authFetch } from "utils";

export const getAll = (companyId) =>
  authFetch(`${apiUrl}${version}/companies/${companyId}/company_access_requests`, {
    method: "GET",
  });

export const accept = (id) =>
  authFetch(`${apiUrl}${version}/company_access_requests/${id}/accept`, {
    method: "PATCH",
  });

export const reject = (id) =>
  authFetch(`${apiUrl}${version}/company_access_requests/${id}/reject`, {
    method: "PATCH",
  });

export const create = (companyId) =>
  authFetch(`${apiUrl}${version}/companies/${companyId}/company_access_requests`, {
    method: "POST",
  });
